import { render, staticRenderFns } from "./QSelectTags.vue?vue&type=template&id=79080d34&"
import script from "./QSelectTags.vue?vue&type=script&lang=js&"
export * from "./QSelectTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports